import React from "react";
import ErrorBoundary from "src/components/errorboundary/errorboundary.v1";
import IframesModule from "src/modules/iframes";

const SliceComponent = (props: any) => {
  const { sliceContext } = props;
  return <>
  <ErrorBoundary fallback={null}>
    <IframesModule data={{ selectedLanguage: sliceContext.language, item: sliceContext.item }} />
  </ErrorBoundary>
  </>
}

export default SliceComponent;